import Select from 'react-select'

import { defaultDropdownStyles } from '@/components/Clients/ClientProfileView/helpers'

export type DoorOption = { id: string; name: string }

const dropdownStyles = {
  ...defaultDropdownStyles(),
  menuPortal: (base: Record<string, unknown>) => ({ ...base, zIndex: 9999 }),
}

interface DoorMultiSelectProps {
  // Note: not passed by every caller — a react-select control isn't a native form element,
  // so it doesn't get disabled for free by IntegrationCard's wrapping <fieldset>; providers
  // must forward the `disabled` prop they receive from `Fields` here explicitly.
  disabled?: boolean
  isConfigured: boolean
  isLoading: boolean
  onChange: (doors: DoorOption[]) => void
  options: DoorOption[]
  placeholder: string
  value: DoorOption[]
}

const getEmptyOptionsMessage = (isLoading: boolean, configured: boolean) => () => {
  if (isLoading) return 'Loading...'
  if (configured) return 'No doors found for this building'
  return 'No doors available for this building'
}

export const DoorMultiSelect = ({
  disabled,
  isConfigured,
  isLoading,
  onChange,
  options,
  placeholder,
  value,
}: DoorMultiSelectProps) => (
  <Select
    isClearable
    isMulti
    closeMenuOnSelect={false}
    getOptionLabel={(option: DoorOption) => option.name}
    getOptionValue={(option: DoorOption) => option.id}
    isDisabled={isLoading || disabled}
    isLoading={isLoading}
    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
    menuPosition="fixed"
    noOptionsMessage={getEmptyOptionsMessage(isLoading, isConfigured)}
    options={options}
    placeholder={placeholder}
    styles={dropdownStyles}
    value={value}
    onChange={(selected: readonly DoorOption[] | null) =>
      onChange((selected ?? []) as DoorOption[])
    }
  />
)
